<router-outlet></router-outlet>
<app-loading *ngIf="'default' | swIsLoading | async"></app-loading>
